export const isVerified = (verifiedAt?: string | null): boolean =>
  Boolean(verifiedAt)

export const isSuspended = (suspendedAt?: string | null): boolean =>
  Boolean(suspendedAt)

export type AccountRestriction = 'suspended' | 'unverified'

export const getAccountRestriction = ({
  suspendedAt,
  verifiedAt,
  isImpersonating,
}: {
  suspendedAt?: string | null
  verifiedAt?: string | null
  isImpersonating: boolean
}): AccountRestriction | null => {
  if (isImpersonating) return null

  if (isSuspended(suspendedAt)) return 'suspended'

  if (!isVerified(verifiedAt)) return 'unverified'

  return null
}
